// Sdílené UI tokeny pro finanční moduly (AOP vrstvy, Výsledovka).
// Dřív byla akcentní modrá zapsaná třemi způsoby (ACCENT / SECTION_COLOR / inline
// '#3B82F6') a tabulková pozadí hardcoded v každém souboru zvlášť. Tady je pravda.

// Modulový akcent — Finance = modrá (Směny mají vlastní fialovou).
export const ACCENT = '#3B82F6';

// Sémantické barvy
export const OK = '#10b981';      // kladná marže/EBITDA, DPH 12 %, výnos
export const BAD = '#ef4444';     // mazání, záporná EBITDA, chyba
export const WARN = '#f59e0b';    // zamčené hodnoty (lock), semi-variabilní
export const VIOLET = '#8b5cf6';  // DPH 21 %, ubytování
export const TEAL = '#0cc0df';    // pacing značka „dnes", tržby (Přehled)
export const ORANGE = '#f97316';  // rozvoz (kanál)

// Barvy prodejních kanálů — sdílené AOP vrstvami i Výsledovkou. Dřív si je
// každá vrstva psala vlastním hexem (a rozcházely se).
export const KANAL_BARVA = {
    rozvoz: ORANGE,
    vydej: OK,
    bistro: ACCENT,
    ubytovani: VIOLET,
    ostatni: WARN,
};

// Barvy energetických médií (AOP Energie, Výsledovka).
export const ENERGIE_BARVA = { voda: ACCENT, plyn: WARN, elektrina: '#eab308' };

// Kategorie materiálu — v tmavém režimu tlumenější, aby nezářily.
export function materialBarvy(isDark) {
    return {
        suroviny: isDark ? '#199e70' : '#1baf7a',
        zbozi:    isDark ? '#3987e5' : '#2a78d6',
        obaly:    isDark ? '#c98500' : '#eda100',
    };
}

// Jednotná šířka měsíčního sloupce (dřív kolísalo 80/84/96/122 px).
export const W_MESIC = 112;

// Kanonický „glass" styl karty podle motivu. Sdílí Finance i editor směn —
// dřív měl každý modul vlastní (jinou průhlednost, blur i vnitřní stín).
export function cardStyle(isDark) {
    return isDark ? {
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.10)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06)',
    } : {
        background: 'var(--surface-raised)',
        border: '1px solid var(--border-default)',
        boxShadow: 'var(--shadow-xs)',
    };
}

// Pozadí tabulkových ploch podle motivu — sticky sloupce, hlavičky, skupiny,
// zvýrazněné řádky (marže/EBITDA).
//
// **Neutrálně, nikdy do modra.** Stupně jsou ty z `app.css` (`--surface-base`
// #0A0A0C, `--surface-raised` #141416, `--surface-elevated` #1C1C20) plus jeden
// krok nad nimi na skupinový řádek. Do 3.480.0 tu stálo `#171723 / #1c1c2b /
// #20202f` — modrá složka o 12–15 výš než R a G — a `strongBg` byl modrý závoj
// `rgba(59,130,246,0.12)` přes celý řádek. Na velké ploše tmavého motivu to bylo
// vidět okamžitě a brandbook studené modré zakazuje. Zvýraznění řádku proto nese
// neutrální plocha a akcentní **linka**, ne tón; akcent sekce smí být text,
// ikona, rámeček nebo pruh, ne podklad.
export function tableSurfaces(isDark) {
    return {
        stickyBg: isDark ? '#141416' : '#ffffff',
        headBg:   isDark ? '#1C1C20' : '#f4f4f5',
        groupBg:  isDark ? '#232327' : '#ededee',
        strongBg: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.05)',
    };
}

// Světlé sklo pro karty, které jsou v tmavém motivu skleněné. Hodnoty žijí
// v CSS (--glass-*) — ladí se na jednom místě a přepnutí tématu je okamžité.
export const SKLO_SVETLE = {
    background: 'var(--glass-bg)',
    border: '1px solid var(--glass-border)',
    boxShadow: 'var(--glass-shadow)',
    backdropFilter: 'var(--glass-blur)',
    WebkitBackdropFilter: 'var(--glass-blur)',
};

// Modály a popovery (detail KPI, detail dne, filtr, náhled dokumentu…) —
// skleněný panel ve stejném jazyce jako karty Přehledu a se stejným zaoblením
// (rounded-xl). Hodnoty v CSS (--modal-*), obě témata.
export const MODAL_SKLO = {
    background: 'var(--modal-bg)',
    border: '1px solid var(--modal-border)',
    boxShadow: 'var(--modal-shadow)',
    backdropFilter: 'var(--modal-blur)',
    WebkitBackdropFilter: 'var(--modal-blur)',
    borderRadius: 'var(--radius-xl, 8px)',
};

/**
 * Materiál navigačních vrstev na mobilu — lišta, vysouvací sloupce, menu
 * modulů, zásuvka panelu.
 *
 * Dřív si ho každá vrstva míchala sama a vyšlo z toho **šest receptů na totéž
 * sklo**: rozostření 6, 10, 28, 32, 40 a 56 px a saturace 1,35 / 170 % / 200 %.
 * Lišta a menu, o kterých dokumentace tvrdila, že jsou „dvě plochy téhož
 * systému", se lišily dvojnásobně. Krytí sdílely, rozostření ne — a materiál
 * dělá rozostření.
 *
 * 32 px je zároveň strop, který na iOS ještě neubírá plynulost scrollu pod
 * lištou; 56 px přes celou šířku byl nejdražší efekt v aplikaci.
 */
export const ROZOSTRENI_NAVIGACE = 'blur(32px) saturate(180%)';

/** Clona pod vysunutou vrstvou (sloupec sekcí, list účtu). */
export const ROZOSTRENI_CLONY = 'blur(6px)';

// Ztmavení plochy pod modálem.
export const MODAL_POZADI = {
    background: 'var(--modal-backdrop)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
};
